import { useNavigate } from "react-router-dom"
import useTargetStorage from "@/hooks/useTargetStorage"
import Callout from "components/callout/callout"
import { useTranslation } from "react-i18next"
import CreateSupplierForm from "features/storages/suppliers/createSupplierForm"
import useSuppliers from "hooks/useSuppliers"
import useStorages from "hooks/useStorages"
import Section from "components/layout/section"
import SectionHeader from "components/layout/sectionHeader"
import SectionHeaderTitle from "components/layout/sectionHeaderTitle"
import RightSidebar from "components/sidebar/right/RightSidebar"
import PageTitle from "features/navigation/pageTitle"
import { paramGuardStorage } from "@/utils/paramGuard"
import { FormStatus } from "@/types"

const CreateSupplier = () => {

    const { t } = useTranslation()
    const navigate = useNavigate()

    const { targetStorageDocId: storageId } = useTargetStorage()

    const {
        suppliersStatus
    } = useSuppliers({ storageId })

    const { 
        storage,
        storageStatus,
        isSuppliersEnabled
    } = useStorages({ storageId })

    // Check params and declare safe ones to use in JSX
    if (!paramGuardStorage({storageId, storage, storageStatus, navigate})) {
        return <></>
    }
    const safeStorageId = storageId!;

    // Redirect if suppliers are disabled for this storage
    if (!isSuppliersEnabled()) {
        navigate(`/storage`);
        return <></>;
    }

    const onSuccess = (supplierId: string) => {
        navigate(`/storage/suppliers/${supplierId}`)
    }

    // Return the JSX.
    return (
        <>
            <PageTitle title={t('titleCreateSupplier')} />
            <CreateSupplierForm storageId={safeStorageId} onSuccess={onSuccess} />
            <RightSidebar />
        </>
    )

}

export default CreateSupplier
